<template>
	<main class="common-main-container">
		<header>
			<h1 class="d-flex align-items-center">
				<img
					class="mr-3"
					src="../../../assets/common-icons/BackArrow.svg"
					alt=""
				/>
				Configure
			</h1>
			<b-button @click="$router.push({ name: 'AddConfig' })" class="new-addBtn">
				<img
					class="mr-2"
					src="../../../assets/common-icons/whiteAdd.svg"
					alt=""
				/>
				Configuration
			</b-button>
		</header>
		<body class="my-2">
			<b-container class="configuration-container">
				<section>
					<header
						class="d-flex align-items-center justify-content-between config-header"
					>
						<h1>List of Configuration</h1>
						<div class="position-relative">
							<b-button class="new-addBtn">
								<img
									class="mr-2"
									src="../../../assets/common-icons/whitefilter.svg"
									alt=""
								/>
								Filter
							</b-button>
							<div class="config-filter-dropdown">
								<SingleSelect :optionsArray="dataDpd" :text="'Test Type'" />
								<div
									class="d-flex align-items-center justify-content-between filter-buttons mt-4"
								>
									<b-button>Cancel</b-button>
									<span>
										<b-button class="mr-3">Reset</b-button>
										<b-button>Apply</b-button>
									</span>
								</div>
							</div>
						</div>
					</header>
					<div class="config-table-container p-3">
						<b-row class="config-selected">
							<div class="green-bar-2"></div>
							<b-col
								cols="3"
								class="d-flex align-items-center config-radio-parent"
							>
								<b-form-radio></b-form-radio>
								<div>
									<h2>Configuration Name</h2>
									<h3>Config 3</h3>
								</div>
							</b-col>
							<b-col cols="3">
								<h2>Tagged To</h2>
								<h3>Group 1 and 7 others</h3>
							</b-col>
							<b-col cols="2">
								<h2>Starting Time</h2>
								<h3>09/09/2022</h3>
							</b-col>
							<b-col cols="2">
								<h2>Ending Time</h2>
								<h3>09/09/2022</h3>
							</b-col>
							<b-col
								cols="2"
								class="d-flex align-items-center justify-content-center"
							>
								<img
									class="mr-3"
									src="../../../assets/common-icons/view.svg"
									alt=""
								/>
								<img src="../../../assets/common-icons/edit.svg" alt="" />
							</b-col>
						</b-row>
						<b-row class="config-table-header"
							><b-col cols="2" class="pl-4"
								><span class="ml-3">Name</span>

								<img
									src="../../../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-2"
								/>
							</b-col>
							<b-col cols="2"
								>Tagged to
								<img
									src="../../../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-2"
							/></b-col>
							<b-col cols="2"
								>Start Date
								<img
									src="../../../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-2"
							/></b-col>
							<b-col cols="1"
								>End Date
								<img
									src="../../../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-2"
							/></b-col>
							<b-col cols="2" class="pl-5"
								>Test Type
								<img
									src="../../../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-2"
							/></b-col>
							<b-col cols="1"
								>Status
								<img
									src="../../../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-2"
							/></b-col>
							<b-col cols="2" class="justify-content-center"
								>Action</b-col
							></b-row
						>
						<div class="config-table-overflow">
							<b-row
								v-for="i in loopvar"
								:key="i"
								class="config-data-row"
								:class="i == 1 ? 'config-sel-row' : ''"
							>
								<div :class="i % 2 == 0 ? 'red-bar' : 'green-bar'"></div>
								<b-col
									cols="2"
									class="d-flex align-items-center pl-2 config-radio-parent"
								>
									<b-form-radio></b-form-radio>
									<span class="text-truncate">
										Emily Johnson
									</span>
								</b-col>
								<b-col cols="2">
									john.smith@example.com
								</b-col>
								<b-col cols="2">12.09.2024</b-col>
								<b-col cols="1">12.09.2024</b-col>
								<b-col cols="2" class="pl-5">
									<span class="ml-1">Private</span>
								</b-col>
								<b-col cols="1">
									<span v-if="i % 2 == 0" class="red-txt ml-1">Expired</span>
									<span v-else class="green-txt ml-1">Active</span>
								</b-col>
								<b-col
									cols="2"
									class="d-flex align-items-center justify-content-center pl-4"
								>
									<img
										class="mr-3"
										src="../../../assets/common-icons/view.svg"
										alt=""
									/>
									<img src="../../../assets/common-icons/edit.svg" alt="" />
								</b-col>
							</b-row>
						</div>
					</div>
				</section>
				<footer>
					<b-button class="new-cancelBtn mr-3">
						Cancel
					</b-button>
					<b-button class="new-addBtn">
						Select Configuration
					</b-button>
				</footer>
			</b-container>
		</body>
	</main>
</template>

<script>
import SingleSelect from "../../../components/InputComponents/SingleSelect.vue";
export default {
	name: "ConfigurationList",
	data() {
		return {
			loopvar: 20,
			dataDpd: [
				{ text: "abc", value: 1 },
				{ text: "xyz", value: 2 },
				{ text: "123", value: 3 },
				{ text: "456", value: 4 },
				{ text: "qwe", value: 5 },
				{ text: "abc", value: 6 },
				{ text: "xyz", value: 7 },
				{ text: "123", value: 8 },
				{ text: "456", value: 9 },
				{ text: "qwe", value: 10 },
			],
		};
	},
	components: {
		SingleSelect,
	},
};
</script>

<style>
/* configuration designs start */
.configuration-container {
	max-width: 100%;
	margin: 0;
	padding: 0;
	border-radius: 4px;
	overflow: hidden;
}

.configuration-container section {
	background-color: #f5f5f5;
	height: 30%;
}

.configuration-container footer {
	background-color: #ffffff;
	display: flex;
	justify-content: end;
	align-items: center;
	border-top: 1px solid #d7d7d7;
	height: 65px;
	padding-inline: 15px;
}

.config-table-header {
	background: #72738e14;
	font-family: "Lato", sans-serif;
	font-size: 14px;
	font-weight: 600;
	color: #72738e;
	padding: 10px 15px;
	margin-inline: 2px;
}

.config-table-header .col-1,
.config-table-header .col-2,
.config-table-header .col-3 {
	display: flex;
	align-items: center;
}

.config-table-overflow {
	height: calc(100vh - 280px);
	overflow-y: auto;
	overflow-x: hidden;
	width: 100%;
}

.config-data-row {
	font-family: "Lato", sans-serif;
	font-size: 15px;
	font-weight: 400;
	color: #72738e;
	background-color: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	padding: 10px 15px;
	margin: 10px 5px;
	position: relative;
	height: 55px;
}

.red-txt {
	color: #e70016;
}

.green-txt {
	color: #038e00;
}

.red-bar {
	width: 2px;
	height: 38px;
	border-radius: 2px;
	position: absolute;
	left: 2px;
	top: 3px;
	background-color: #eb0018;
}

.green-bar {
	width: 2px;
	height: 38px;
	border-radius: 2px;
	position: absolute;
	left: 2px;
	top: 3px;
	background-color: #038e00;
}

.green-bar-2 {
	width: 4px;
	height: 54px;
	border-radius: 2px;
	position: absolute;
	left: 2px;
	top: 3px;
	background-color: #038e00;
}

.config-selected h2 {
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 400;
	color: #696969;
}

.config-selected h3 {
	font-family: "Lato", sans-serif;
	font-size: 15px;
	font-weight: 400;
	color: #72738e;
	margin-bottom: 0;
}

.config-sel-row {
	background-color: #e8e8eb;
}

.left-215 {
	left: 215px;
}

.left-430 {
	left: 430px;
}

.left-645 {
	left: 645px;
}

/* configuration designs end */
</style>
